import { render, staticRenderFns } from "./SelectRadioField.vue?vue&type=template&id=13c6325a&scoped=true"
import script from "./SelectRadioField.vue?vue&type=script&lang=js"
export * from "./SelectRadioField.vue?vue&type=script&lang=js"
import style0 from "./SelectRadioField.vue?vue&type=style&index=0&id=13c6325a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6325a",
  null
  
)

export default component.exports